export enum TemplateTabs {
	Default = "default",
	Cargos = "cargos",
	Agreements = "agreements"
}
